export default __webpack_public_path__ + "clientapp/media/robot-05.95731d15.png";